<template>
  <aRow :gutter="20">
    <aCol class="a-right" :span="24">
      <a-tooltip placement="left" title="Recuperar dados do contratante">
        <a-button
          size="small"
          type="primary"
          shape="circle"
          icon="user"
          @click="getCustomerData(clientId)"
        >
        </a-button>
      </a-tooltip>
    </aCol>
    <aCol :span="24">
      <aRow :gutter="20">
        <aCol :span="7">
          <aFormItem>
            <label :class="'filled'">Nome</label>
            <aInput
              class="travel-input"
              placeholder="Nome"
              v-decorator="[
                `third_party_client_first_name_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
            >
              <aIcon slot="prefix" type="field-svg" />
            </aInput>
          </aFormItem>
        </aCol>

        <aCol :span="7">
          <aFormItem>
            <label :class="'filled'">Sobrenome</label>
            <aInput
              class="travel-input"
              placeholder="Sobrenome"
              v-decorator="[
                `third_party_client_last_name_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
            >
              <aIcon slot="prefix" type="field-svg" />
            </aInput>
          </aFormItem>
        </aCol>

        <aCol :span="10">
          <aFormItem>
            <label :class="'filled'">Email</label>
            <aInput
              class="travel-input"
              placeholder="Email"
              v-decorator="[
                `third_party_client_email_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      type: 'email',
                      message: 'Escreva um e-mail válido',
                    },
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
            >
              <aIcon slot="prefix" type="field-svg" />
            </aInput>
          </aFormItem>
        </aCol>

        <aCol :span="5">
          <aFormItem>
            <label :class="'filled'">Nascimento</label>
            <a-date-picker
              class="travel-input"
              placeholder="Nascimento"
              format="DD/MM/YYYY"
              v-mask="'##/##/####'"
              :showToday="false"
              :disabled-date="adultHoodDate"
              @openChange="defaultDate"
              v-decorator="[
                `third_party_client_birthday_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
            >
            </a-date-picker>
          </aFormItem>
        </aCol>

        <aCol :span="5">
          <aFormItem>
            <label :class="'filled'">CPF</label>
            <aInput
              class="travel-input"
              placeholder="CPF"
              v-mask="'###.###.###-##'"
              v-decorator="[
                `third_party_client_CPF_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      min: 9,
                      message: 'Preencha todos números.',
                    },
                  ],
                },
              ]"
            >
              <aIcon slot="prefix" type="field-svg" />
            </aInput>
          </aFormItem>
        </aCol>

        <aCol :span="5">
          <aFormItem>
            <label :class="'filled'">RG</label>
            <aInput
              class="travel-input"
              placeholder="RG"
              v-mask="['##.###.###', '#.###.###', '###.###.###-##']"
              v-decorator="[
                `third_party_client_RG_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                    {
                      min: 9,
                      message: 'Preencha todos números',
                    },
                  ],
                },
              ]"
            >
              <aIcon slot="prefix" type="field-svg" />
            </aInput>
          </aFormItem>
        </aCol>
        <aCol :span="5">
          <aFormItem>
            <label :class="'filled'">Órgão Emissor</label>
            <aInput
              class="travel-input"
              placeholder="Órgão Emissor"
              v-decorator="[
                `third_party_client_doc_emission_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
            >
              <aIcon slot="prefix" type="field-svg" />
            </aInput>
          </aFormItem>
        </aCol>

        <aCol :span="4">
          <aFormItem>
            <label :class="'filled'">ES</label>
            <a-select
              class="travel-input"
              show-search
              placeholder="ES"
              v-decorator="[
                `third_party_client_doc_emission_state_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
            >
              <a-select-option
                v-for="(item, index) of states"
                :key="index"
                :value="item.initials"
              >
                {{ item.initials.toUpperCase() }}
              </a-select-option>
            </a-select>
          </aFormItem>
        </aCol>

        <aCol :span="6">
          <aFormItem>
            <label :class="'filled'">Telefone fixo</label>
            <aInput
              class="travel-input"
              placeholder="Telefone fixo"
              v-mask="'(##) ####-####'"
              v-decorator="[
                `third_party_client_phone_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
            >
              <aIcon slot="prefix" type="field-svg" />
            </aInput>
          </aFormItem>
        </aCol>

        <aCol :span="6">
          <aFormItem>
            <label :class="'filled'">Celular</label>
            <aInput
              class="travel-input"
              placeholder="Celular"
              v-mask="'(##) # ####-####'"
              v-decorator="[
                `third_party_client_mobile_phone_${clientId}${keySuffix}`,
              ]"
            >
              <aIcon slot="prefix" type="field-svg" />
            </aInput>
          </aFormItem>
        </aCol>
        <aCol :span="6">
          <aFormItem>
            <label :class="'filled'">CEP</label>
            <aInput
              class="travel-input"
              placeholder="CEP"
              v-mask="'#####-###'"
              v-decorator="[
                `third_party_client_CEP_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
              @change="getLocation()"
            >
              <aIcon slot="prefix" type="field-svg" />
              <aIcon v-if="cepLoading" slot="suffix" type="loading" />
            </aInput>
          </aFormItem>
        </aCol>
        <aCol :span="8">
          <aFormItem>
            <label :class="'filled'">Logradouro</label>
            <aInput
              class="travel-input"
              placeholder="Logradouro"
              v-decorator="[
                `third_party_client_location_street_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
            >
              <aIcon slot="prefix" type="field-svg" />
            </aInput>
          </aFormItem>
        </aCol>
        <aCol :span="4">
          <aFormItem>
            <label :class="'filled'">Número</label>
            <aInput
              type="number"
              class="travel-input"
              placeholder="Número"
              v-decorator="[
                `third_party_client_location_number_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
            >
              <aIcon slot="prefix" type="field-svg" />
            </aInput>
          </aFormItem>
        </aCol>

        <aCol :span="6">
          <aFormItem>
            <label :class="'filled'">Complemento</label>
            <aInput
              class="travel-input"
              placeholder="Complemento"
              v-decorator="[
                `third_party_client_location_complement_${clientId}${keySuffix}`,
              ]"
            >
              <aIcon slot="prefix" type="field-svg" />
            </aInput>
          </aFormItem>
        </aCol>
        <aCol :span="6">
          <aFormItem>
            <label :class="'filled'">Bairro</label>
            <aInput
              class="travel-input"
              placeholder="Bairro"
              v-decorator="[
                `third_party_client_location_neighborhood_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
            >
              <aIcon slot="prefix" type="field-svg" />
            </aInput>
          </aFormItem>
        </aCol>
        <aCol :span="6">
          <aFormItem>
            <label :class="'filled'">Cidade</label>
            <aInput
              class="travel-input"
              placeholder="Cidade"
              v-decorator="[
                `third_party_client_location_city_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
            >
              <aIcon slot="prefix" type="field-svg" />
            </aInput>
          </aFormItem>
        </aCol>
        <aCol :span="6">
          <aFormItem>
            <label :class="'filled'">Estado</label>
            <a-select
              class="travel-input"
              show-search
              placeholder="ES"
              v-decorator="[
                `third_party_client_location_state_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
            >
              <a-select-option
                v-for="(item, index) of states"
                :key="index"
                :value="item.initials"
              >
                {{ item.initials.toUpperCase() }}
              </a-select-option>
            </a-select>
          </aFormItem>
        </aCol>
        <aCol :span="6" :offset="6">
          <aFormItem>
            <label :class="'filled'">Valor pago (R$)</label>
            <aInput
              class="travel-input"
              placeholder="Valor pago (R$)"
              v-currency
              v-decorator="[
                `third_party_client_paid_value_${clientId}${keySuffix}`,
                {
                  rules: [
                    {
                      required: true,
                      message: 'Obrigatório',
                    },
                  ],
                },
              ]"
              @blur="updateTotalThirdPartyValue"
            >
              <aIcon slot="prefix" type="field-svg" />
            </aInput>
          </aFormItem>
        </aCol>
      </aRow>
    </aCol>
  </aRow>
</template>

<script>
import axios from "axios";
import subYears from "date-fns/subYears";
import { format } from "date-fns";

export default {
  name: "ThirdPartyCollapse",
  props: {
    tempContract: Object,
    form: Object,
    clientId: Number,
    keyPrefix: String,
    keySuffix: String,
    reservation_total_price: Number,
  },
  data() {
    return {
      states: [
        { name: "Acre", initials: "AC" },
        { name: "Alagoas", initials: "AL" },
        { name: "Amapá", initials: "AP" },
        { name: "Amazonas", initials: "AM" },
        { name: "Bahia", initials: "BA" },
        { name: "Ceará", initials: "CE" },
        { name: "Distrito Federal", initials: "DF" },
        { name: "Espírito Santo", initials: "ES" },
        { name: "Goiás", initials: "GO" },
        { name: "Maranhão", initials: "MA" },
        { name: "Mato Grosso", initials: "MT" },
        { name: "Mato Grosso do Sul", initials: "MS" },
        { name: "Minas Gerais", initials: "MG" },
        { name: "Pará", initials: "PA" },
        { name: "Paraíba", initials: "PB" },
        { name: "Paraná", initials: "PR" },
        { name: "Pernambuco", initials: "PE" },
        { name: "Piauí", initials: "PI" },
        { name: "Rio de Janeiro", initials: "RJ" },
        { name: "Rio Grande do Norte", initials: "RN" },
        { name: "Rio Grande do Sul", initials: "RS" },
        { name: "Rondônia", initials: "RO" },
        { name: "Roraima", initials: "RR" },
        { name: "Santa Catarina", initials: "SC" },
        { name: "São Paulo", initials: "SP" },
        { name: "Sergipe", initials: "SE" },
        { name: "Tocantins", initials: "TO" },
      ],
      cepLoading: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.form.setFieldsValue({
        [`third_party_client_first_name_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_first_name_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_last_name_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_last_name_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_email_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_email_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_birthday_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_birthday_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_phone_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_phone_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_mobile_phone_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_mobile_phone_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_CEP_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_CEP_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_location_neighborhood_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_location_neighborhood_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_location_number_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_location_number_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_location_complement_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_location_complement_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_location_street_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_location_street_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_location_city_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_location_city_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_location_state_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_location_state_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_RG_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_RG_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_doc_emission_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_doc_emission_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_doc_emission_state_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_doc_emission_state_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_CPF_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_CPF_${this.clientId}${this.keySuffix}`
          ],
        [`third_party_client_paid_value_${this.clientId}${this.keySuffix}`]:
          this.tempContract[
            `third_party_client_paid_value_${this.clientId}${this.keySuffix}`
          ],
      });
    }, 50);
  },
  methods: {
    updateTotalThirdPartyValue() {
      this.$emit("updateTotalThirdPartyValue");
    },
    getCustomerData() {
      this.form.setFieldsValue({
        [`third_party_client_first_name_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.first_name.toUpperCase(),
      });

      this.form.setFieldsValue({
        [`third_party_client_last_name_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.last_name.toUpperCase(),
      });

      this.form.setFieldsValue({
        [`third_party_client_email_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.email.toUpperCase(),
      });

      this.form.setFieldsValue({
        [`third_party_client_birthday_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.birthday,
      });

      this.form.setFieldsValue({
        [`third_party_client_phone_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.phone,
      });

      this.form.setFieldsValue({
        [`third_party_client_location_neighborhood_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.location_neighborhood.toUpperCase(),
      });

      this.form.setFieldsValue({
        [`third_party_client_location_state_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.location_state,
      });

      this.form.setFieldsValue({
        [`third_party_client_mobile_phone_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.mobile_phone.toUpperCase(),
      });

      this.form.setFieldsValue({
        [`third_party_client_CEP_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.cep.toUpperCase(),
      });

      this.form.setFieldsValue({
        [`third_party_client_location_number_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.location_number,
      });

      this.form.setFieldsValue({
        [`third_party_client_location_complement_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.location_complement.toUpperCase(),
      });

      this.form.setFieldsValue({
        [`third_party_client_location_city_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.location_city.toUpperCase(),
      });

      this.form.setFieldsValue({
        [`third_party_client_location_street_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.location_street.toUpperCase(),
      });

      this.form.setFieldsValue({
        [`third_party_client_RG_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.rg,
      });

      this.form.setFieldsValue({
        [`third_party_client_doc_emission_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.rg_emissor,
      });

      this.form.setFieldsValue({
        [`third_party_client_doc_emission_state_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.rg_state,
      });

      this.form.setFieldsValue({
        [`third_party_client_CPF_${this.clientId}${this.keySuffix}`]:
          this.tempContract.the_customer.cpf,
      });
    },
    getLocation() {
      setTimeout(() => {
        if (
          this.form.getFieldValue(
            `third_party_client_CEP_${this.clientId}${this.keySuffix}`
          )
        ) {
          if (
            this.form
              .getFieldValue(
                `third_party_client_CEP_${this.clientId}${this.keySuffix}`
              )
              .replace("-", "").length == 8
          ) {
            this.cepLoading = true;
            axios
              .get(
                "https://viacep.com.br/ws/" +
                  this.form.getFieldValue(
                    `third_party_client_CEP_${this.clientId}${this.keySuffix}`
                  ) +
                  "/json/"
              )
              .then(({ data }) => {
                this.cepLoading = false;

                setTimeout(() => {
                  this.form.setFieldsValue({
                    [`third_party_client_location_street_${this.clientId}${this.keySuffix}`]:
                      data.logradouro.toUpperCase(),
                    [`third_party_client_location_state_${this.clientId}${this.keySuffix}`]:
                      data.uf,
                  });

                  this.form.setFieldsValue({
                    [`third_party_client_location_city_${this.clientId}${this.keySuffix}`]:
                      data.localidade.toUpperCase(),
                    [`third_party_client_location_neighborhood_${this.clientId}${this.keySuffix}`]:
                      data.bairro.toUpperCase(),
                  });

                  this.tempContract[
                    `third_party_client_location_street_${this.clientId}${this.keySuffix}`
                  ] = data.logradouro.toUpperCase();
                  this.tempContract[
                    `third_party_client_location_state_${this.clientId}${this.keySuffix}`
                  ] = data.uf;
                  this.tempContract[
                    `third_party_client_location_city_${this.clientId}${this.keySuffix}`
                  ] = data.localidade.toUpperCase();
                  this.tempContract[
                    `third_party_client_location_neighborhood_${this.clientId}${this.keySuffix}`
                  ] = data.bairro.toUpperCase();
                }, 50);
              })
              .catch(({ response }) => {
                response;
                this.$message.error(
                  "Houve um problema ao recuperar a localização."
                );
                this.cepLoading = false;
              });
          }
        }
      }, 110);
    },
    defaultDate() {
      setTimeout(() => {
        this.form.setFieldsValue({
          [`third_party_client_birthday_${this.clientId}${this.keySuffix}`]:
            this.form.getFieldValue(
              `third_party_client_birthday_${this.clientId}${this.keySuffix}`
            )
              ? this.form.getFieldValue(
                  `third_party_client_birthday_${this.clientId}${this.keySuffix}`
                )
              : format(subYears(new Date(), 18), "MM/dd/yyyy"),
        });
      }, 1);
    },
    adultHoodDate(current) {
      return current && current > subYears(new Date(), 18);
    },
  },
};
</script>

<style scoped lang="scss">
label {
  position: absolute;
  z-index: 4;
  font-size: 10px;
  font-weight: 500;
  color: #ccc;
  transition: 0.3s;
  opacity: 0;
  top: 13px;
  left: 0;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
  &.filled {
    top: -16px;
    opacity: 1 !important;
  }
}
</style>
